import { Role } from '../../mappers/business/toBusinessModel';
import { BusinessRegistrationStatus } from '../../mappers/users/toUserModel';
import type { BusinessUI } from '../business/types';

export enum CollectionStatus {
    PUBLISHED = 'published',
    DECLINED = 'declined',
    MODERATION = 'moderation',
    DRAFT = 'draft',
}

export type UserUI = {
    id: string;
    profile?: BusinessUI;
    subscriptions: number;
    avatarUrl?: string;
    displayName: string;
    login: string;
    role: Role;
    businessRegistrationStatus?: BusinessRegistrationStatus;
};

type MediaImageUI = {
    id: string;
    type: 'image';
    media: Inspire.Image[];
};

export type MediaVideoUI = {
    id: string;
    type: 'video';
    media: Inspire.Video[];
};

export type PreviewItemUI = MediaImageUI | MediaVideoUI;

export interface CollectionUI {
    id: string;
    url: string;
    displayName: string;
    numberOfPosts: number;
    previewItems: PreviewItemUI[];
    modifiable: boolean;
    defaultCollection: boolean;
    isPublic: boolean;
    sharingUrl: string;
    author?: {
        id: string;
        displayName: string;
        avatarUrl: Inspire.Image[];
    };
    status: CollectionStatus;
    isLiked: boolean;
    likes: number;
    footerData?: {
        feedButtonText: string;
    };
}

export interface CollectionPersistenceUI {
    id?: string;
    displayName: string;
    isPublic: boolean;
}
